import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const WeekCard = styled("div", {
  shouldForwardProp(propName) {
    return (
      propName !== "topPercent" &&
      propName !== "heightPercent" &&
      propName !== "leftPercent" &&
      propName !== "isVip" &&
      propName !== "isAssigned" &&
      propName !== "isGroup" &&
      propName !== "isSmall"
    );
  },
})<{
  topPercent?: number;
  heightPercent?: number;
  leftPercent?: number;
  isVip?: boolean;
  isAssigned?: boolean;
  isGroup?: boolean;
  isSmall?: boolean;
}>(({ leftPercent, topPercent, heightPercent, isVip, isAssigned, isGroup, isSmall }) => {
  let backgroundColor: string;

  if (isVip) {
    backgroundColor = isAssigned ? colors.warning25 : colors.gray50;
  } else {
    backgroundColor = isAssigned ? colors.brandBlue25 : colors.gray50;
  }

  return {
    left: `${leftPercent || 0}%`,
    top: `calc(${topPercent || 0}% - 0px)`,
    height: `calc(${heightPercent || 0}% - 2px)`,
    minHeight: isSmall ? "68px" : "100px",
    position: "absolute",
    cursor: "pointer",
    width: "100%",
    border: `1px ${isAssigned || isGroup ? "solid" : "dashed"} ${
      isAssigned || isGroup ? colors.brandBlue50 : colors.gray300
    }`,

    padding: "4px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    backgroundColor,

    "&:hover": {
      boxShadow: "0px 0px 12px rgba(147, 169, 189, 0.25)",
      zIndex: "50",
    },
  };
});

export const WeekCardTitle = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isVip" && propName !== "isAssigned";
  },
})<{ isVip?: boolean; isAssigned?: boolean }>(({ isVip, isAssigned }) => {
  let textColor: string;

  if (isVip) {
    textColor = isAssigned ? colors.warning500 : colors.gray500;
  } else {
    textColor = isAssigned ? colors.brandBlue500 : colors.gray500;
  }

  return {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: textColor,

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
});

export const WeekCardInfoLine = styled("div")(() => {
  return {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0.4px",
    color: colors.gray600,
  };
});

export const WeekCardTimeLabel = styled("div")(() => {
  return {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.5px",
    color: colors.gray800,

    marginTop: "14px",
  };
});

export const WeekCardBadge = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isVip" && propName !== "isAssigned";
  },
})<{ isVip?: boolean; isAssigned?: boolean }>(({ isVip, isAssigned }) => {
  let backgroundColor: string;

  if (isVip) {
    backgroundColor = colors.warning500;
  } else if (isAssigned) {
    backgroundColor = colors.brandBlue500;
  } else {
    backgroundColor = colors.gray500;
  }

  return {
    display: "inline-flex",

    borderRadius: "100px",
    backgroundColor,
    color: colors.white,
    paddingRight: "4px",
    paddingLeft: "4px",
    minWidth: "18px",
    minHeight: "18px",
    alignItems: "center",
    justifyContent: "center",
  };
});
